import { useTranslation } from "react-i18next";
import { FloatingAccents } from "@/components/decorative";
import { Check } from "lucide-react";

const perks = [
  { emoji: "🎁", textKey: "perks.perk0" },
  { emoji: "💰", textKey: "perks.perk1" },
  { emoji: "🏅", textKey: "perks.perk2" },
  { emoji: "🚀", textKey: "perks.perk3" },
];

export const FoundingMemberPerks = () => {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-24 px-4 overflow-hidden">
        <FloatingAccents position="both" />
        
        <div className="container mx-auto max-w-6xl relative z-10">
          <h2 className="font-clash text-3xl xs:text-4xl md:text-5xl font-bold text-center mb-4 text-foreground tracking-tight">
            {t("perks.headline")}
          </h2>
          
          <p className="text-lg text-muted-foreground text-center max-w-3xl mx-auto mb-12 whitespace-pre-line">
            {t("perks.subtitle")}
          </p>

          <div className="max-w-2xl mx-auto space-y-4">
            {perks.map((perk, index) => (
              <div
                key={index}
                className="flex items-center gap-4 p-4 rounded-lg bg-gradient-to-r from-brand-purple/10 to-brand-teal/10 dark:from-brand-purple/20 dark:to-brand-teal/20 hover:from-brand-purple/20 hover:to-brand-teal/20 dark:hover:from-brand-purple/30 dark:hover:to-brand-teal/30 hover:scale-105 hover:shadow-lg transition-all duration-300 cursor-pointer"
              >
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-brand-teal flex items-center justify-center">
                  <Check className="w-6 h-6 text-white" strokeWidth={3} />
                </div>
                <p className="text-lg font-semibold text-foreground">
                  {perk.emoji} {t(perk.textKey)}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <p className="text-base text-muted-foreground">
              {t("socialProof.subtext")}
            </p>
          </div>
        </div>
      </section>
  );
};
